import { arraySearch } from 'helpers/object';

export default {
  getCampaigns: state => (state.catalog.campaigns === null ? [] : state.catalog.campaigns),
  getCampaignDetail: state => state.campaignDetail,
  getResourcesKey: state => (key, attribute = null) =>
    state.static ? arraySearch(state.static, 'id', key, attribute) : null,
  getEmail: state => state.catalog.emailPresales,
  getLogos: state => ({
    logoLeft: state.catalog.logoLeft,
    logoRight: state.catalog.logoRight,
    logoCust: state.catalog.logoCust
  }),
  getCustomerName: state => state.catalog.name,
  getFilters: state => state.filters,
  getPartnersNoContract: state => state.partnersNoContract
};
